import type { TranslationFunctions } from '@i18n/i18n-types';
import { ReportReason } from '@shared/types/report';

export function translateReason($LL: TranslationFunctions, reason: ReportReason | string): string {
    return {
        [ReportReason.Other]: $LL.reportReason.other(),
        [ReportReason.Harassment]: $LL.reportReason.harassment(),
        [ReportReason.Scam]: $LL.reportReason.scam(),
        [ReportReason.Animals]: $LL.reportReason.depictionOfAnimals(),
        [ReportReason.Spam]: $LL.reportReason.spam(),
        [ReportReason.MoreOneInChat]: $LL.reportReason.moreOneInChat(),
        [ReportReason.NoOneInChat]: $LL.reportReason.noOneInChat(),
        [ReportReason.Underage]: $LL.reportReason.depictionOfMinors(),
        [ReportReason.HateSpeech]: $LL.reportReason.hate(),
        [ReportReason.Violence]: $LL.reportReason.violence(),
        [ReportReason.Illegal]: $LL.reportReason.illegal(),
        [ReportReason.Nudity]: $LL.reportReason.nudity(),
        [ReportReason.InappropriateBehavior]: $LL.reportReason.inappropriateBehavior(),
        [ReportReason.HateSpeechLegacy]: $LL.reportReason.hateSpeech(),
        [ReportReason.InappropriateContent]: $LL.reportReason.inappropriateContent(),
        [ReportReason.MoreOneInVideo]: $LL.reportReason.moreOneInVideo(),
        [ReportReason.NoOneInVideo]: $LL.reportReason.noOneInVideo(),
        [ReportReason.DuplicateAccount]: $LL.reportReason.duplicateAccount(),
        [ReportReason.AutoDetectNudity]: $LL.reportReason.autoDetectNudity(),
    }[reason] ?? reason;
}
